import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'

const drawerWidth = 300;

const materialTheme = createTheme(({
    // set default for now
}));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    fullWidth: {
        width: "100%"
    },
}));


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UserSettings = (props) => {
    const classes = useStyles();

    const [isSavingUser, setIsSavingUser] = useState(false)
    const [showMessageDialog, setShowMessageDialog] = useState(false)
    const [isSavingSuccess, setIsSavingSuccess] = useState(false)
    const [messageDialogMessage, setMessageDialogMessage] = useState("")
    const [emailVerificationDialogMessage, setEmailVerificationDialogMessage] = useState(false)
    const [isSavingEmailVerificationSuccess, setIsSavingEmailVerificationSuccess] = useState(false)
    const [isEmailVerified, setIsEmailVerified] = useState(0);
    const [user, setUser] = useState({
        id: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        mobile_number: "",
        username: "",
        user_type: 0,
        email_address: ""
    })



    const inputOnChangeListener = (event) => {
        const modifiedUser = { ...user }

        modifiedUser[event.target.name] = event.target.value
        setUser(modifiedUser)
    }

    const [emailVerificationCode, setEmailVerificationCode] = useState({
        email_verification_code: ""
    })

    const inputOnChangeEmailVerificationListener = (event) => {
        const modifiedEmailVerificationCode = { ...emailVerificationCode }
        modifiedEmailVerificationCode[event.target.name] = event.target.value
        setEmailVerificationCode(modifiedEmailVerificationCode)
    }
    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);

        return formData;
    }, new FormData())

    useEffect(() => {
        getUserDetails();
    }, [props.openDialogSettings])

    const getUserDetails = async () => {
        const options = {
            method: 'POST',
            url: '/User/getUserInformationDetails.json'
        }

        const response = await axios(options)
        const is_success = response.data.response.is_success;
        const user_details = response.data.response.user_info;
        if (is_success) {

            const edit_user = { ...user }

            edit_user.first_name = user_details.first_name;
            edit_user.last_name = user_details.last_name;
            edit_user.middle_name = user_details.middle_name;
            edit_user.mobile_number = user_details.mobile_number;
            edit_user.username = user_details.username;
            edit_user.id = user_details.id;
            edit_user.user_type = user_details.type;
            edit_user.email_address = user_details.email_address;
            setUser(edit_user)
            setIsEmailVerified(user_details.email_verified)
        }
    }

    const handleClick = () => {
        const newUserDetails = { ...user }
        setIsSavingUser(true)
        const options = {
            method: 'POST',
            url: '/User/sendTransactiEmailOtp.json',
            data: objectToFormData(newUserDetails)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message
                const paragraphToCheck = "The email verification code has been successfully sent to";

                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingEmailVerificationSuccess(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setIsSavingUser(false)

                    if (res.data.response.message == 'Sorry, requests are limited to once every 5 minute') {
                        setIsSavingEmailVerificationSuccess(true)
                    }

                    return;
                }
                if (message.includes(paragraphToCheck)) {
                    setIsSavingSuccess(false);
                    setEmailVerificationDialogMessage(true)
                } else {
                    setIsSavingEmailVerificationSuccess(false)
                    setEmailVerificationDialogMessage(false)
                }
                
                
                setIsSavingUser(false)
                setMessageDialogMessage(res.data.response.message)
                setShowMessageDialog(true)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)


            })
    };

    const updateAccount = (event) => {
        const newUserDetails = { ...user }
        setIsSavingUser(true)
        const options = {
            method: 'POST',
            url: '/User/updateUserTransacti.json',
            data: objectToFormData(newUserDetails)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message

                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingUser(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setIsSavingEmailVerificationSuccess(false)

                    return;
                }
                setIsSavingSuccess(true)
                setIsSavingUser(false)
                setMessageDialogMessage("Account save successfully.")
                setIsSavingEmailVerificationSuccess(false)
                setShowMessageDialog(true)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
            })
    }

    const verifyEmailOtp = (event) => {
        // setIsSavingUser(true)
        const newEmailVerificationCode = { ...emailVerificationCode }
        const options = {
            method: 'POST',
            url: '/User/validateEmailOtp.json',
            data: objectToFormData(newEmailVerificationCode)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message
                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingUser(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setEmailVerificationDialogMessage(true)
                    setIsSavingEmailVerificationSuccess(true)


                    return;
                }
                setIsSavingEmailVerificationSuccess(false)
                setIsSavingSuccess(true)
                setIsSavingUser(false)
                setMessageDialogMessage(message)
                setShowMessageDialog(true)
                setEmailVerificationDialogMessage(false)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)


            })

    }

    function progressDialog() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={isSavingUser}
                onClose={() => { }}
            >

                <DialogContent>
                    <DialogContentText>
                        Processing... Please wait...
                    </DialogContentText>
                    <LinearProgress color="secondary" />
                </DialogContent>
            </Dialog>
        )
    }


    function messageDialog() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={showMessageDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {messageDialogMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setShowMessageDialog(false)

                        if (isSavingSuccess) {
                            props.setOpenDialogSettings(false)
                            setEmailVerificationCode({ email_verification_code: "" });
                            window.location.reload();
                        }

                        if (isSavingEmailVerificationSuccess) {
                            setEmailVerificationDialogMessage(true)
                        }

                    }}
                        color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    function verifyEmailDialog() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={emailVerificationDialogMessage}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Verify Email Address"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Grid container spacing={1} style={{ marginBottom: '.5rem' }}>
                            <Grid item xs={12} >Email Verification Code</Grid>
                            <Grid item xs={12}>
                                <StyledEngineProvider injectFirst>
                                    <ThemeProvider theme={materialTheme}>
                                        <form noValidate>
                                            <TextField
                                                autoComplete='off'
                                                className={classes.fullWidth}
                                                value={emailVerificationCode.email_verification_code}
                                                name="email_verification_code"
                                                id="email-verification-code"
                                                rows={4}
                                                variant="outlined"
                                                onChange={inputOnChangeEmailVerificationListener}
                                            />
                                        </form>
                                    </ThemeProvider>
                                </StyledEngineProvider>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setEmailVerificationDialogMessage(false)
                        getUserDetails()
                        setEmailVerificationCode({ email_verification_code: "" });
                        // if (isSavingSuccess) {
                        //     props.setOpenDialogSettings(false)
                        // }

                    }}
                        color="primary" autoFocus>
                        CLose
                    </Button>
                    <Button onClick={verifyEmailOtp}
                        color="primary" autoFocus>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    
    return (
        <div>

            <Dialog fullScreen open={props.openDialogSettings} onClose={() => {


            }} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => {
                                props.setOpenDialogSettings(false)
                            }


                            }
                            aria-label="close"
                            size="large">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="subtitle1" className={classes.title}>
                            {"User Settings"}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className={classes.appBarSpacer}></div>
                <div style={{ padding: '.5rem' }}>

                    <Grid container spacing={1}>
                        <Grid container spacing={1}>

                            <Grid item xs={4}>
                                <Grid item xs={12} >First name*</Grid>
                                <Grid item xs={12}>
                                    <StyledEngineProvider injectFirst>
                                        <ThemeProvider theme={materialTheme}>
                                            <form noValidate>
                                                <TextField
                                                    autoComplete='off'
                                                    type='text'
                                                    className={classes.fullWidth}
                                                    value={user.first_name}
                                                    name="first_name"
                                                    id="first-name"
                                                    rows={4}
                                                    variant="outlined"
                                                    onChange={inputOnChangeListener}
                                                />
                                            </form>
                                        </ThemeProvider>
                                    </StyledEngineProvider>
                                </Grid>
                            </Grid>
                            <Grid item xs={4}>
                                <Grid item xs={12} >Middle name</Grid>
                                <Grid item xs={12}>
                                    <StyledEngineProvider injectFirst>
                                        <ThemeProvider theme={materialTheme}>
                                            <form noValidate>
                                                <TextField
                                                    autoComplete='off'
                                                    className={classes.fullWidth}
                                                    value={user.middle_name}
                                                    name="middle_name"
                                                    id="middle-name"
                                                    rows={4}
                                                    variant="outlined"
                                                    onChange={inputOnChangeListener}
                                                />
                                            </form>
                                        </ThemeProvider>
                                    </StyledEngineProvider>
                                </Grid>
                            </Grid>
                            <Grid item xs={4}>
                                <Grid item xs={12} >Last name*</Grid>
                                <Grid item xs={12}>
                                    <StyledEngineProvider injectFirst>
                                        <ThemeProvider theme={materialTheme}>
                                            <form noValidate>
                                                <TextField
                                                    autoComplete='off'
                                                    className={classes.fullWidth}

                                                    value={user.last_name}
                                                    name="last_name"
                                                    id="last-name"
                                                    rows={4}
                                                    variant="outlined"
                                                    onChange={inputOnChangeListener}
                                                />
                                            </form>
                                        </ThemeProvider>
                                    </StyledEngineProvider>
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} >Contact Number</Grid>
                        <Grid item xs={12}>
                            <StyledEngineProvider injectFirst>
                                <ThemeProvider theme={materialTheme}>
                                    <form noValidate>
                                        <TextField
                                            className={classes.fullWidth}
                                            value={user.mobile_number}
                                            name="mobile_number"
                                            id="mobile_number"
                                            rows={4}
                                            variant="outlined"
                                            onChange={inputOnChangeListener}
                                        />
                                    </form>
                                </ThemeProvider>
                            </StyledEngineProvider>
                        </Grid>

                        <Grid item xs={12} >Username*</Grid>
                        <Grid item xs={12}>
                            <StyledEngineProvider injectFirst>
                                <ThemeProvider theme={materialTheme}>
                                    <form noValidate>
                                        <TextField
                                            className={classes.fullWidth}
                                            value={user.username}
                                            name="username"
                                            id="username"
                                            rows={4}
                                            variant="outlined"
                                            onChange={inputOnChangeListener}
                                            disabled={true}
                                        />
                                    </form>
                                </ThemeProvider>
                            </StyledEngineProvider>
                        </Grid>

                        <Grid item xs={12}>
                            Email Address*&nbsp;&nbsp;
                            {/* {isEmailVerified == 0 && (
                                <sup style={{ cursor: 'pointer', color: 'red', fontSize: 'smaller' }}>
                                    Your email address is not yet verified
                                </sup>
                            )} */}
                        </Grid>
                        <Grid item xs={12}>
                            <StyledEngineProvider injectFirst>
                                <ThemeProvider theme={materialTheme}>
                                    <form noValidate>
                                        <TextField
                                            className={classes.fullWidth}
                                            value={user.email_address}
                                            name="email_address"
                                            id="email_address"
                                            rows={4}
                                            variant="outlined"
                                            onChange={inputOnChangeListener}
                                        />
                                    </form>
                                </ThemeProvider>
                            </StyledEngineProvider>
                        </Grid>
                        {isEmailVerified == 0 && (
                            <Grid item xs={12}>
                                Your email address is not yet verified &nbsp;

                                <u style={{ cursor: 'pointer', color: 'blue', fontSize: 'smaller' }} onClick={handleClick}>
                                    Click here to verify.
                                </u>
                            </Grid>
                        )}
                        <Grid item container >
                            <Button variant="contained" color="primary" style={{ width: "100%" }} onClick={updateAccount}>
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Dialog>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                    {progressDialog()}
                    {messageDialog()}
                    {verifyEmailDialog()}
                </ThemeProvider>
            </StyledEngineProvider>
        </div>
    );
}

export default UserSettings